import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from "vuex";
export default {
  props: {
    component: Object
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    show: function show(state) {
      return state.design.show_component_form;
    }
  })), {}, {
    slideStyle: function slideStyle() {
      if (this.show) {
        return "\n      opacity: 1;\n      transform: translateX(0);\n      visibility: visible;\n      ";
      } else {
        return "\n      opacity: 0;\n      transform: translateX(-280px);\n      visibility: hidden;\n      ";
      }
    }
  })
};